<template>
    <div 
        @mouseover.self="tooltipinfoHoverIn($event, 'Add to Moodboard')" 
        @mouseleave.self="tooltipinfoHoverOut($event)" 
        ref="addFav" 
        class="fav add-fav" 
        :data_id="imageID" 
        :class="bannerIsFav" 
        @click="addFav(imageID)"
    ></div>
    <div 
        @mouseover.self="tooltipinfoHoverIn($event, 'Remove from Moodboard')" 
        @mouseleave.self="tooltipinfoHoverOut($event)" 
        ref="removeFav" 
        class="fav remove-fav" 
        :class="bannerIsFav" 
        @click="removeFav(imageID)"
    ></div>
</template>

<script>
import axios from 'axios';

export default {
    name: "fav-button",
    props: {
        imageID: {
            type: Number
        }
    },
    data() {
        return {
            bannerIsFav: ''
        };
    },
    methods: {
        addFav (id) {
            const e1 = this.$refs.addFav.classList;
            const e2 = this.$refs.removeFav.classList;

            e2.add('d-block');
            e2.add('opacity-none');
            setTimeout(() => {
                e2.add('opacity-one');
                e2.remove('opacity-none');
            }, 25);
            setTimeout(() => {
                e1.add('selected');
                e2.add('selected');

                e2.remove('d-block');
                e2.remove('opacity-one');
            }, 275);

            axios.get(`/moodboardapi/item/${id}/toggle/?${Date.now()}`)
                .then(response => {
                    const message = {
                        title: 'Item added to moodboard',
                        text: '<a href="/inspiration/mood-board/">Item added to moodboard</a>',
                    }
                    
                    this.appendtoNotification(message);
                    this.toggleNotificationMoodboard();
                })
                .catch(error => {
                    console.log(error);
                })
            

        },
        removeFav (id) {
            const e1 = this.$refs.addFav.classList;
            const e2 = this.$refs.removeFav.classList;

            var classStr = e2.value;
            var hasRemove = classStr.includes("fav remove-fav selected remove");
            
            if (hasRemove) {
                this.$el.classList.add('fade-out');    
            }

            e1.remove('selected');
            e2.add('d-block');
            e2.add('opacity-one');
            setTimeout(() => {
                e2.add('opacity-none');
                e2.remove('opacity-one');
            }, 25);
            setTimeout(() => {
                e2.remove('selected');
                e2.remove('opacity-one');
                e2.remove('d-block');
            }, 275);

            axios.get(`/moodboardapi/item/${id}/toggle/?${Date.now()}`)
                .then(response => {
                    const message = {
                        title: 'Item removed from moodboard',
                        text: '<a href="/inspiration/mood-board/">Item removed from moodboard</a>',
                    };

                    this.appendtoNotification(message);
                    this.toggleNotificationMoodboard();
                })
                .catch(error => {
                    console.log(error);
                })

        }
    },
    mounted() {
        const separator = '%2C';
        const cookieValue = this.simpleCookieGet('MoodBoard');
        this.bannerIsFav = cookieValue.split(separator).includes( this.imageID.toString() ) ? 'selected' : '';
    }
}
</script>